export const singleData = {
    iframeTabs: [
        { title: 'Exterior', key: 'EXT' },
        { title: 'Interior', key: 'INT' }
    ]
}